import * as React from "react";
import * as _ from "lodash";
import * as moment from "moment";
import { IDonorEvalRecord } from "@nkr/models/index";
import { toast } from "react-toastify";
import { DonorEvalQuery } from '@nkr/enums/index';
import { Button, InputGroup, FormControl, Badge, Label, OverlayTrigger, Popover, Glyphicon } from 'react-bootstrap';
import { toPath } from "lodash";
import ReactHtmlParser from 'react-html-parser';


interface IProps {
    rank: number,
    data: IDonorEvalRecord,
    query: DonorEvalQuery,
    updatePayment: (donorEvalRecord: IDonorEvalRecord) => void
}

interface IState {
    [index: string]: string | number | boolean,
    paidDate: string,
    achNumber: string,
    amountOwed: number,
    inputChange : boolean
}


class DonorEvalRow extends React.Component<IProps, IState> {
    readonly state: IState = {
        achNumber: '',
        paidDate: '',
        amountOwed: 0,
        inputChange: false
    }


    handleInputChange = (e: React.FormEvent<HTMLInputElement & FormControl>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        this.setState({
            [name]: value,
            inputChange: true
        });
    }


    componentDidUpdate(prevList) {

        if(prevList.data != this.props.data)
        {
            
            if(this.props.data.paidDateTime == null && !this.state.inputChange)
            {
                this.setState({
                    paidDate: this.props.data.paidDateTime != null ? moment(this.props.data.paidDateTime).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")   
                });
            } 
        }
        
      } 

    componentDidMount = () => {

        this.setState({
            paidDate: this.props.data.paidDateTime != null ? moment(this.props.data.paidDateTime).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD") 
        });
    }

    handlePaymentUpdate = () => {
        //validate all information is populated

        if (this.state.achNumber.length == 0 || this.state.paidDate.length == 0) {
            toast.error('Missing fields.  Please validate data.');
            return;
        }

        let rowData = _.cloneDeep(this.props.data);
        rowData.achConfirmation = this.state.achNumber;
        rowData.paidDateTime = this.state.paidDate;
        rowData.donorEvalBillType = this.props.data.donorEvalBillType;
     
        this.props.updatePayment(rowData);

        this.setState({
            achNumber: '',
            paidDate: '',
            inputChange: true
        });
    }


    getOverlay = (swapnumber: string) => {
 
        return (
            <Popover>
                {ReactHtmlParser(swapnumber)}
            </Popover>
        );
    }

    getAlertOverlay = (paydate: string) => {

        return (       
                 <Popover>
                    {ReactHtmlParser("Center has outstanding balance > 60 days")}
                </Popover>          
        );
    }

    render = () => {
        var isPaid = this.props.data.paidDateTime != null && this.props.data.paidDateTime.length > 0;
        return (
            <>
            <tr>
                    <td style={{ maxWidth: '10px' }}>{this.props.rank}</td>        
                    <td>{this.props.data.workupBillType}</td>
                    <td>{this.props.data.donorCenterAlias}</td>
                    <td style={{ width: "40px" }}>
                        {this.props.data.donorAlias}
                    </td>
                    <td>{this.props.data.recipCenterAlias}</td>
                    <td>
                        {this.props.data.recipAlias}
                    </td>
                    <td>{this.props.data.workUpDate !== null ?   moment(this.props.data.workUpDate).format('YYYY-MM-DD') : ''}</td>
                    <td>{this.props.data.transplantDate !== null ? moment(this.props.data.transplantDate).format('YYYY-MM-DD') : ''}</td>
                    <td>{this.props.data.invoiceDate !== null ? moment(this.props.data.invoiceDate).format('YYYY-MM-DD') : ''}</td>


                    <td style={{ textAlign: "center" }}>
                        {(this.props.data.paymentDueAmount == 0
                            ? '--'
                            : this.props.data.paymentDueAmount.toLocaleString('en', { style: "currency", currency: "USD", maximumFractionDigits: 0  }))
                        }
                    </td>

                    <td>
                        <OverlayTrigger trigger={this.props.data.paymentDueDate == null ? ['hover', 'focus']: null}
                            placement="right" overlay={this.getAlertOverlay(this.props.data.paymentDueDate)}>
                            <div>
                                {this.props.data.ccbPayableDays == null ? <Label bsStyle='danger' style={{ fontSize: '80%' }}>Do Not Pay</Label> :
                                    this.props.data.paymentDueDate == null ? <Label bsStyle='danger' style={{ fontSize: '80%' }}>N/A</Label> :
                                        this.props.data.hasLate ? <Label bsStyle='warning' style={{ fontSize: '80%' }}>{moment(this.props.data.paymentDueDate).format('YYYY-MM-DD')}</Label> :
                                    <Label bsStyle='success' style={{ fontSize: '80%' }}>{moment(this.props.data.paymentDueDate).format('YYYY-MM-DD')}</Label>}
                            </div>
                        </OverlayTrigger>             
                    </td>
                    <td>
                        <Glyphicon glyph={this.props.data.donorCenterHasAchOnFile == true ? 'ok' : ''} style={{ marginLeft: 5 }} />
                    </td>
                    <td>
              
                        <td>
                            <OverlayTrigger trigger={['hover', 'focus']} 
                                placement="right" overlay={this.getOverlay(this.props.data.previousBilling)}>
                            <div>
                                    {this.props.data.previousBilling != null ? this.props.data.previousBilling.substring(0, 15).length == 0 ? '' : <Glyphicon glyph='warning-sign' style={{ marginLeft: 5 }} value={this.props.data.previousBilling.substring(0, 15) + '...' }/> : ''}
                            </div>
                            </OverlayTrigger>           
                        </td>

                    </td>
        
                    <td>
                    {this.props.query == DonorEvalQuery.ToDo && (<>
                    {isPaid ? <Badge>{moment(this.props.data.paidDateTime).format("MM/DD/YYYY")}</Badge> : <InputGroup className="mb-3" style={{ display: "flex", width: "170px" }}>
                        <FormControl
                            type="date"
                            name="paidDate"
                            value={this.state.paidDate}
                            onChange={this.handleInputChange}
                        />
                            </InputGroup>} </>)}


                        {this.props.query == DonorEvalQuery.Paid && (<>

                            <span>{moment(this.props.data.paidDateTime).format("MM/DD/YYYY")}</span> </>)}
                </td>
                    <td>

                        {this.props.query == DonorEvalQuery.ToDo && (<>
                          {isPaid ? this.props.data.achConfirmation : <InputGroup className="mb-3" style={{ display: "flex" }}>
                        <FormControl
                            type="text"
                            placeholder="ACH Confirmation"
                            name="achNumber"
                            value={this.state.achNumber}
                            onChange={this.handleInputChange} />
                            </InputGroup>} </>)}

                        {this.props.query == DonorEvalQuery.Paid && (<>

                            <span>{this.props.data.achConfirmation }</span> </>)}
                </td>
                    <td>

                        {this.props.query == DonorEvalQuery.ToDo && (<>

                            {isPaid ? <Badge>Paid</Badge> :
                                <Button onClick={this.handlePaymentUpdate} bsSize="small" className="btn-primary" id="button-addon2">
                                    Mark Paid
                                </Button>} </>)}

                        {this.props.query == DonorEvalQuery.Paid && (<>

                            <span></span> </>)}

                </td>
            </tr>
            </>
        )
    }
}

export default DonorEvalRow;